import React from "react";
import PropTypes from "prop-types";
import { Grid, Skeleton, Typography } from "@mui/material";
import { SearchInput } from "app/components";
import { FormattedMessage, injectIntl } from "react-intl";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { HasAccessTo } from "app/components/Authorization";
import { EMPLOYER } from "../../../../common/Authorization/entities";
import { EDIT } from "../../../../common/Authorization/permissions";
import { ActionButton } from "../../../../components/ActionButton";
import { DivRootStyled } from "./EmployersToolbar.styles";
export const ADD_EMPLOYERS_TOOLBAR_TEST_ID = "add-employers-toolbar";
const EmployersToolbar = (props) => {
  const { className, handleClickAdd, handleSearch, intl, totalCount, initialSearchQuery } = props;
  const disabledIfNoAccessToEmployerEdit = !HasAccessTo(EMPLOYER, EDIT);
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "menu.employers" })), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase" }, typeof totalCount !== "undefined" ? /* @__PURE__ */ React.createElement(FormattedMessage, { id: "employers.totalCount", values: { totalCount } }) : /* @__PURE__ */ React.createElement(Skeleton, { width: 200 }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(
    SearchInput,
    {
      onChange: handleSearch,
      placeholder: intl.formatMessage({ id: "employers.search" }).toUpperCase(),
      initialSearchQuery
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4, sx: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
    ActionButton,
    {
      messageId: "employers.add",
      onClick: handleClickAdd,
      disabled: disabledIfNoAccessToEmployerEdit,
      icon: faPlus,
      testId: ADD_EMPLOYERS_TOOLBAR_TEST_ID
    }
  ))));
};
EmployersToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired
};
export default injectIntl(EmployersToolbar);
